import { Page } from './components/Page';
import { ApiProvider } from './context/Api';
import { BackgroundColorProvider } from './context/BackgroundColor';
import { ConfigProvider } from './context/Config';
import { FillColorProvider } from './context/FillColor';
import { IconProvider } from './context/Icons';
import { SearchProvider } from './context/Search';

type IconLibraryProps = Partial<IconLibraryConfig>;

const IconLibrary = (props: IconLibraryProps) => {
  return (
    <ConfigProvider {...props}>
      <ApiProvider>
        <FillColorProvider>
          <BackgroundColorProvider>
            <SearchProvider>
              <IconProvider>
                <Page />
              </IconProvider>
            </SearchProvider>
          </BackgroundColorProvider>
        </FillColorProvider>
      </ApiProvider>
    </ConfigProvider>
  );
};

IconLibrary.defaultProps = {
  svgFillColors: 'black|white|red|green|blue',
  defaultSvgFillColor: '',
  svgBackgroundColors: 'black|white|red|green|blue',
  defaultBackgroundFillColor: '',
  searchCategories: '',
  listItemStyles: '',
  realm: undefined,
  pngOutputSizes: '16,32,64,128,256,512',
} as IconLibraryProps;

export default IconLibrary;
